import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom, userReceivedAction } from '@root/entities/auth/atoms'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { redirectToTwitterAction } from './reatom-twitter-redirect'
import {
  assignTwitterRequestAction,
  unassignTwitterRequestAction,
} from './twitter-requests'

import type { OAuthCode } from '@root/entities/auth'

export const redirectToTwitterAssignAction = action((ctx) => {
  redirectToTwitterAction(ctx, 'assign')
}, 'redirectToTwitterAssignAction')

export const reatomUnassignTwitter = () => {
  return reatomRequest({
    execAction: unassignTwitterRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomUnassignTwitter',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('common.something_went_wrong_try_again'),
          intent: 'error',
        })
        return
      }

      showSnackbarAction(ctx, {
        text: i18next.t('settings.twitter.unassign-success'),
        intent: 'success',
      })
      userReceivedAction(ctx, result.success)
    },
  })
}

export const assignTwitterAction = action(async (ctx, code: OAuthCode) => {
  const isLoggedIn = ctx.get(isLoggedInAtom)
  if (!isLoggedIn) {
    return
  }

  const result = await ctx.schedule(() =>
    assignTwitterRequestAction(ctx, { authCode: code }),
  )
  if (Result.isSuccess(result)) {
    showSnackbarAction(ctx, {
      text: i18next.t('settings.twitter.success'),
      intent: 'success',
    })
    userReceivedAction(ctx, result.success)
    return
  }

  showSnackbarAction(ctx, {
    text: i18next.t('settings.twitter.connect-error'),
    description: i18next.t('common.something_went_wrong_try_again'),
    intent: 'error',
  })
}, 'assignTwitterAction')
